import { HostingEnvironment, type AppRegistryCallbackContext } from '@opengov/psp-contract';
import { resolveDevModuleUrl } from './utils';

/**
 * The origin gab-core serves its web app and PSP module from in this build's environment:
 * `VITE_GAB_CORE_ORIGIN` in the committed `.env.<mode>` file, required by the build's env
 * validation. Every entitlement URL for one of its apps must be on it. It ignores the
 * local-module override: entitlements are written by the deployed gab-core, so a locally served
 * module still receives URLs on this origin.
 */
export const gabCoreOrigin = (): string => import.meta.env.VITE_GAB_CORE_ORIGIN;

/**
 * gab-core's PSP ES-module URL: its origin plus the stable `/psp/index.js` entry the module build
 * emits (a fixed filename, so the URL is stable across deploys). App Builder and every gab-core
 * app with a dynamic entitlement mount this one module.
 */
export const gabCoreModuleUrl = (ctx: AppRegistryCallbackContext): string => {
  const moduleUrl = `${gabCoreOrigin()}/psp/index.js`;
  // Locally, a gab-core PSP module build when VITE_DEV_MODULE_URL_APP_BUILDER is set.
  return ctx.hostingEnvironment === HostingEnvironment.DEVELOPMENT
    ? resolveDevModuleUrl('APP_BUILDER', moduleUrl)
    : moduleUrl;
};

/**
 * The one path every gab-core app mounts under. The module is mounted once here and its own router
 * resolves the rest, so an app's URL in the shell is `/a` plus the path of its entitlement URL
 * (e.g. `/a/cadescity/permits`).
 */
export const GAB_APPS_MOUNT_PATH = '/a';
